import { render, staticRenderFns } from "./ratio.vue?vue&type=template&id=130a7428&scoped=true&"
import script from "./ratio.vue?vue&type=script&lang=js&"
export * from "./ratio.vue?vue&type=script&lang=js&"
import style0 from "./ratio.vue?vue&type=style&index=0&lang=less&"
import style1 from "./ratio.vue?vue&type=style&index=1&id=130a7428&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130a7428",
  null
  
)

export default component.exports